module.exports = __webpack_public_path__ + "img/workout-notebook_B095QBZ9RX.5b6b34a8.jpg";